module.exports = __webpack_public_path__ + "static/6-503b182e61ab952a085c96e52b5b4d9d.jpg";